type CaseStudyImage = {
    path: string,
    ext: string,
    alt: string,    
}

type CaseStudy = {
    code: string,
    name: string,
    labels?: string[],
    liveurl?: string,
    thumb: CaseStudyImage,

    image_hero: CaseStudyImage,
    brief?: string,

    introheading?: string,
    introtitle?: string,
    intro?: string,

    image_about?: CaseStudyImage,
    abouttitle?: string,
    about?: string,

    image_challenge?: CaseStudyImage,
    challengetitle?: string,
    challenge?: string,

    image_solution?: CaseStudyImage,
    solutiontitle?: string,
    solution?: string,

    image_benefits?: CaseStudyImage,
    benefitstitle?: string,
    benefits?: string,

    image_end?: CaseStudyImage,
    endtitle?: string,
    end?: string,

    results?: CaseStudyResult[],
}

type CaseStudyResult = {
    number: string,
    type: string,
    label: string,
}

const casestudies: CaseStudy[] = [
    {
        code: 'tefal',
        name: 'Tefal Shop Direct-to-Consumer',
        labels: ['kitchen','house'],
        liveurl: 'shop.tefal.ro',
        thumb: {
            path: '../../assets/casestudies/tefal/thumb',
            ext: 'png',
            alt: 'Studiu de caz Tefal',
        },

        image_hero: {
            path: '../../assets/casestudies/tefal/hero',
            ext: 'png',
            alt: 'Studiu de caz Tefal',
        },
        brief: 'Tefal lansează canalul de vânzare Direct-to-Consumer folosind Zento',

        introheading: 'Lansarea unui nou canal Direct-to-Consumer',

        introtitle: '<h3>Schimbarea aduce tot timpul un grad de incertitudine și anxietate.</h3>',
        intro: "<p>Ultimul lucru de care ai nevoie este de un proces impredictibil.</p>"
            + "<p>Acesta este motivul pentru care am proiectat un proces de lansare ușor de urmărit, rafinat în ani de experiență, astfel încât să urmărești ușor statusul proiectului tău.</p>",
        
        image_about: {
            path: '../../assets/casestudies/tefal/about',
            ext: 'png',
            alt: 'Studiu de caz Tefal',
        },
        abouttitle: "<h2>Un lider absolut în bucătărie</h2>",
        about: "<p>Tefal este un brand de tradiție în piața din România și lider mondial pentru articole de bucătărie și îngrijire personală.</p>"
            + "<p>Groupe SEB, compania care deține brandul Tefal, este prezent în peste 150 de țări și deține un portofoliu unic de peste 30 de branduri de top. De la crearea sa, compania a fost un jucător cheie prin produsele sale inovative care îmbunătățesc viața consumatorilor din lumea întreagă.</p>"
            + "<p>Compania are o strategie pe termen lung concentrată pe inovație, dezvoltare internațională, competitivitate și servicii oferite clienților. Multi-cultural și multi-creativ, compania are peste 34,000 de angajați în peste 60 de țări, cu o viziune comună în dezvoltare sustenabilă, profesionalism și pasiune pentru inovație.</p>",
        
        image_challenge: {
            path: '../../assets/casestudies/tefal/worldmap',
            ext: 'png',
            alt: 'Tefal Worldwide',
        },
        challenge: "<p>Fiind parte dintr-un grup multinațional prezent în peste 150 de țări, magazinul Tefal trebuie să respecte standardele ridicate de conformitate și securitate impuse la nivel central.</p>"
            + "<p>Un element prioritar în noul canal direct-to-consumer a fost prezentarea produselor într-un mod cât mai detaliat, pentru a veni în ajutorul clienților care vor să achiziționeze sau doar să se informeze despre un produs și caracteristicile sale.</p>"
            + "<p>Scalabilitatea și extensibilitatea soluției pe termen lung sunt de asemenea un element important pentru noul magazin, iar disponibilitatea unor integrări avansate și extensibilitatea pentru viitoare integrări a fost un alt aspect cheie în decizia alegerii Zento.</p>"
        ,
    
        image_solution: {
            path: '../../assets/casestudies/tefal/solution',
            ext: 'png',
            alt: 'Tefal Zento Solution UI',
        },
        solution: "<p>Fundația solidă Zento bazată pe Magento 2 a îndeplinit în totalitate nevoile de conformitate, securitate și stabilitate la nivel global pentru Tefal și a oferit garanția suportului pe termen lung.</p>"
            + "<p>Design-ul personalizat până în cele mai mici detalii a avut ca prioritate organizarea unui catalog ușor de explorat pentru vizitatori și prezentarea produselor cu un nivel de detalii care nu este posibil decât într-o implementare de tip Direct-to-Consumer.</p>"
            + "<p>Frontend-ul PWA inovativ al Zento integrează design-ul într-o experiență superioară utilizatorilor, bazat pe viteză de navigare și timp de răspuns instantaneu.</p>"
            + "<p>Integrările cu soluțiie de ERP, WMS și marketing au fost esențiale în construirea unui canal de vânzare care poate scala odată cu creșterea preconizată.</p>"
            + "<p>Arhitectura de hosting în cloud asigură un echilibru perfect între costuri reduse și scalabilitate în perioade de vârf, iar securitatea este de neegalat pentru soluțiile tradiționale.</p>",
        
        // endtitle: "",
        // end: "",
        
        // results: [
        //     {
        //         number: '+40',
        //         type: '%',
        //         label: "vânzări după lansare",
        //     },
        //     {
        //         number: '+60',
        //         type: '%',
        //         label: "satisfacție clienți",
        //     },
        //     {
        //         number: '-25',
        //         type: '%',
        //         label: "costuri tehnologie",
        //     },
        // ],
    },
    {
        code: 'rowenta',
        name: 'Rowenta Shop Direct-to-Consumer',
        labels: ['beauty','house'],
        liveurl: 'shop.rowenta.ro',
        thumb: {
            path: '../../assets/casestudies/rowenta/thumb',
            ext: 'png',
            alt: 'Studiu de caz Rowenta',
        },

        image_hero: {
            path: '../../assets/casestudies/rowenta/hero',
            ext: 'png',
            alt: 'Studiu de caz Rowenta',
        },
        brief: 'Rowenta lansează canalul de vânzare online Direct-to-Consumer folosind Zento',

        introheading: 'Lansarea unui nou canal de vânzare: Direct-to-Consumer',

        introtitle: '<h3>Lansarea unui nou canal de vânzare are provocările sale, dar tehnologia nu trebuie să fie una dintre ele.</h3>',
        intro: "<p>Pentru un brand de top, lansarea unui nou canal de vânzare este un proces cu o pregătire specială: stocuri distribuite în centre de logistică, echipă de support pregătită să răspundă clienților online, echipă de marketing cu campanii pregătite pentru lansare etc. Ultimul lucru de care ai nevoie este de un proces impredictibil de realizare a magazinului online.</p>"
            + "<p>Acesta este motivul pentru care am proiectat un proces de lansare ușor de urmărit, rafinat în ani de experiență, astfel încât să urmărești ușor statusul proiectului tău.</p>",
        
        image_about: {
            path: '../../assets/casestudies/rowenta/about',
            ext: 'png',
            alt: 'Studiu de caz Rowenta',
        },
        abouttitle: "<h2>Lider în electrocasnice</h2>",
        about: "<p>Rowenta este un brand de tradiție în piața din România și lider mondial pentru articole de îngrijire personală și curățenie.</p>"
            + "<p>Groupe SEB, compania care deține brandul Rowenta, este prezent în peste 150 de țări și deține un portofoliu unic de peste 30 de branduri de top. De la crearea sa, compania a fost un jucător cheie prin produsele sale inovative care îmbunătățesc viața consumatorilor din lumea întreagă.</p>"
            + "<p>Compania are o strategie pe termen lung concentrată pe inovație, dezvoltare internațională, competitivitate și servicii oferite clienților. Multi-cultural și multi-creativ, compania are peste 34,000 de angajați în peste 60 de țări, cu o viziune comună în dezvoltare sustenabilă, profesionalism și pasiune pentru inovație.</p>",
        
        image_challenge: {
            path: '../../assets/casestudies/rowenta/worldmap',
            ext: 'png',
            alt: 'Rowenta Worldwide',
        },
        challenge: "<p>Fiind parte dintr-un grup multinațional prezent în peste 150 de țări, magazinul Rowenta trebuie să respecte standardele ridicate de conformitate și securitate impuse la nivel central.</p>"
            + "<p>Un element prioritar în noul canal D2C a fost prezentarea produselor într-un mod cât mai detaliat, pentru a veni în ajutorul clienților care vor să achiziționeze sau doar să se informeze despre un produs și caracteristicile sale.</p>"
            + "<p>Scalabilitatea și extensibilitatea soluției pe termen lung sunt de asemenea un element important pentru noul magazin, iar disponibilitatea unor integrări avansate și extensibilitatea pentru viitoare integrări a fost un alt aspect cheie în implementarea Zento.</p>"
        ,
        
        image_solution: {
            path: '../../assets/casestudies/rowenta/solution',
            ext: 'png',
            alt: 'Rowenta Zento Solution UI',
        },
        solution: "<p>Fundația solidă Zento bazată pe Magento 2 a îndeplinit în totalitate nevoile de conformitate, securitate și stabilitate la nivel global pentru Rowenta și a oferit garanția suportului pe termen lung.</p>"
            + "<p>Design-ul personalizat până în cele mai mici detalii a avut ca prioritate organizarea unui catalog ușor de explorat pentru vizitatori și prezentarea produselor cu un nivel de detalii care nu este posibil decât într-o implementare de tip Direct-to-Consumer.</p>"
            + "<p>Frontend-ul PWA inovativ al Zento integrează design-ul într-o experiență superioară utilizatorilor, bazat pe viteză de navigare și timp de răspuns instantaneu.</p>"
            + "<p>Integrările cu soluțiie de ERP, WMS și marketing au fost esențiale în construirea unui canal de vânzare care poate scala odată cu creșterea preconizată.</p>"
            + "<p>Arhitectura de hosting în cloud asigură un echilibru perfect între costuri reduse și scalabilitate în perioade de vârf, iar securitatea este de neegalat pentru soluțiile tradiționale.</p>",
        
        // endtitle: "",
        // end: "",
        
        // results: [
        //     {
        //         number: '+40',
        //         type: '%',
        //         label: "vânzări după lansare",
        //     },
        //     {
        //         number: '+60',
        //         type: '%',
        //         label: "satisfacție clienți",
        //     },
        //     {
        //         number: '-25',
        //         type: '%',
        //         label: "costuri tehnologie",
        //     },
        // ],
    },
    {
        code: 'kfea',
        name: 'Kfea',
        labels: ['coffee','house','food & drinks'],
        liveurl: 'www.kfea.ro',
        thumb: {
            path: '../../assets/casestudies/kfea/thumb',
            ext: 'png',
            alt: 'Studiu de caz Kfea',
        },

        image_hero: {
            path: '../../assets/casestudies/kfea/hero',
            ext: 'png',
            alt: 'Studiu de caz Kfea',
        },
        brief: 'Succesul migrării magazinului online Kfea.ro de la Magento 1 la Magento 2 cu ajutorul soluției Zento: Un pas crucial în transformarea digitală a afaceri',

        introheading: 'Kfea.ro din 2006',
        introtitle: '<h3>Kfea.ro este primul și cel mai mare Coffee Shop online din România.</h3>',
        intro: "<p>Cu o vechime de peste 17 ani, au avut grijă să ofere clienților experiențe plăcute prin comercializarea unor produse de calitate, de la o multitudine de sortimente de cafea, la aparate de cafea și produse de întreținere, și produse de vending.</p>",

        image_about: {
            path: '../../assets/casestudies/kfea/about',
            ext: 'png',
            alt: 'Studiu de caz Kfea',
        },
        abouttitle: "<h2>Despre Kfea.ro</h2>",
        about: "<p>Kfea.ro este un brand dedicat iubitorilor de cafea, ce reprezintă o echipă tânără și pasionată, specializată în această artă fascinantă. Cu oameni instruiți și cu experiență în domeniul barista, aceștia oferă consultanță și îndrumare cumpărătorilor, ghidându-i în căutarea cafelei preferate.</p>"
            + "<p>Cu o preocupare profundă pentru mediu, Kfea.ro utilizează exclusiv mașini electrice pentru livrări, contribuind astfel la reducerea impactului asupra mediului înconjurător.</p>"
            + "<p>Cu un sortiment vast ce include branduri de renume mondial precum Lavazza, Saeco, Jura, Gaggia, DeLonghi, Illy și Segafredo și un serviciu dedicat pentru aparatele de cafea, Kfea.ro demonstrează angajamentul său față de calitate și satisfacția clienților săi.</p>"
            + "<p>Kfea.ro este un brand remarcabilă în industria cafelei, demonstrând că pasiunea și atenția față de mediu pot merge mână în mână, aducând în același timp bucurie și satisfacție tuturor iubitorilor de cafea.</p>",
            
        image_challenge: {
            path: '../../assets/casestudies/kfea/challenge',
            ext: 'jpg',
            alt: 'Kfea',
        },
        challengetitle: "<h3>Provocarea migrării de la Magento 1 la Magento 2.</h3>",
        challenge: "<p>Migrarea de la platforma Magento 1 la Magento 2 a reprezentat o provocare semnificativă pentru echipa Zento. Această tranziție a necesitat o planificare atentă și o pregătire adecvată pentru a asigura o migrare completă și o tranziție fără întreruperi pentru magazinul online Kfea.ro.</p>"
            + "<p>Echipa Zento a abordat procesul de migrare într-un mod strategic și etapizat. În primul rând, s-a efectuat o analiză detaliată a magazinului online existent pentru a înțelege în profunzime funcționalitățile și personalizările specifice care trebuiau transferate  și adăugate. Această etapă a fost crucială pentru a identifica toate componentele, și toate echipele implicate în proiect necesare pentru asigurarea unei migrări fără pierderi de date și cu obiectivul de a minimiza impactul replatformizărăii asupra scorului SEO al magazinului online.</p>",

        image_solution: {
            path: '../../assets/casestudies/kfea/solution',
            ext: 'png',
            alt: 'Kfea',
        },
        solutiontitle: "<h3>Magento 2, flexibilitate și control</h3>",
        solution: "<p>Pe lângă migrarea datelor, echipa Zento a recreat și personalizările specifice pentru a se potrivi cu noua arhitectură și funcționalități oferite de Magento 2. Aici intervine expertiza și cunoașterea profundă a echipei în tehnologia Magento, asigurându-se că toate funcțiile personalizate, sunt implementate cu succes. Aceste funcții personalizate au avut un impact semnificativ în creșterea vânzărilor și îmbunătățirea experienței de cumpărare online, contribuind la succesul continuu al magazinului Kfea.ro pe noua platformă Magento 2.</p>"
            + "<p>Echipa Zento a reușit să îndeplinească această provocare cu succes, asigurându-se că magazinul online Kfea.ro beneficiază acum de funcționalități avansate și de o experiență de cumpărare îmbunătățită pe noua platformă Magento 2.</p>",
        
        image_benefits: {
            path: '../../assets/casestudies/kfea/benefits',
            ext: 'png',
            alt: 'Migrare Magento 1 - Magento 2',
        },

        endtitle: "<h3>Beneficiile migrării de la Magento 1 la Magento 2</h3",
        end: "<p>Migrarea magazinului Kfea.ro pe platforma Magento 2 a reprezentat un pas crucial în procesul de transformare digitală a afacerii și a adus o serie de beneficii semnificative. În primul rând, magazinul online a înregistrat o îmbunătățire semnificativă a performanței, inclusiv o creștere a vitezei de încărcare a paginilor și o experiență de cumpărare mai plăcută.</p>"
            + "<p>De asemenea, funcționalitățile noi și personalizările implementate de echipa Zento au contribuit la creșterea vânzărilor și la fidelizarea clienților. În plus, migrarea la Magento 2 a permis magazinului Kfea.ro să beneficieze de o platformă mai flexibilă și scalabilă, pregătită să răspundă cerințelor viitoare de dezvoltare și extindere a afacerii.</p>",
        
        results: [
            {
                label: "Vânzări",
                type: "%",
                number: "+21",
            },
            {
                label: "Comenzi",
                type: "%",
                number: "+28",
            },
            {
                label: "Funcțiionalități noi",
                type: "",
                number: "25",
            },
        ],
    },
    {
        code: 'waterboyz',
        name: 'Waterboyz',
        labels: ['b2b'],
        liveurl: 'www.waterboyz.ro',
        thumb: {
            path: '../../assets/casestudies/waterboyz/thumb',
            ext: 'png',
            alt: 'Studiu de caz Waterboyz',
        },

        image_hero: {
            path: '../../assets/casestudies/waterboyz/hero',
            ext: 'png',
            alt: 'Studiu de caz Waterboyz',
        },
        brief: 'Descoperă cum Seaside Playgrounds a obținut succesul migrând platforma Waterboyz.ro pe Magento 2 într-o colaborare strânsă cu echipa Zento',

        introheading: 'Reușita migrării platformei Waterboyz pe Magento 2: Colaborare de succes între Blugento și Seaside Playgrounds',
        introtitle: '<h3>Replatformizare reușită, creștere număr de clienți, proces vânzare optimizat.</h3>',
        intro: "<p>Compania a obținut rezultate remarcabile prin migrarea platformei lor waterboyz.ro pe Magento 2. Acest succes a fost posibil datorită colaborării strânse dintre echipele de implementare. Prin migrarea și optimizarea platformei, s-au obținut multiple beneficii pentru companie, inclusiv o expunere mai eficientă a catalogului de produse și funcționalități specifice B2B.</p>",

        image_about: {
            path: '../../assets/casestudies/waterboyz/about',
            ext: 'png',
            alt: 'Studiu de caz Waterboyz',
        },
        abouttitle: "<h2>Despre echipa Waterboyz</h2>",
        about: "<p>Seaside Playgrounds este liderul industriei de locuri de joacă din România. Cu o vastă experiență în crearea și comercializarea de produse pentru parcuri și locuri de joacă, compania se concentrează pe calitate, siguranță și inovație. Seaside Playgrounds oferă soluții complete pentru amenajarea și echiparea spațiilor de joacă, punând accent pe satisfacerea nevoilor clienților săi și pe crearea unor experiențe memorabile pentru copii.</p>",
            
        image_challenge: {
            path: '../../assets/casestudies/waterboyz/challenge',
            ext: 'png',
            alt: 'Waterboyz',
        },
        challengetitle: "<h3>Provocarea replatformizării</h3>",
        challenge: "<p>Replatformizarea proiectului Waterboyz.ro pe Magento 2 a implicat provocări semnificative. Echipa Zento a trebuit să migreze cu succes întregul conținut, inclusiv catalogul de produse, funcționalitățile specifice B2B și date SEO, adaptându-le la noile cerințe. Astfel, a fost necesară o planificare atentă, personalizarea designului și optimizarea proceselor de ofertare și vânzare pentru a asigura o tranziție lină și o experiență îmbunătățită pentru clienți. Totodată s-a dorit și o eficientizare a managementului catalogului astfel încât s-a luat în considerare integrare și la nivel de catalog a celor două platforme.</p>",

        image_solution: {
            path: '../../assets/casestudies/waterboyz/solution',
            ext: 'png',
            alt: 'Waterboyz',
        },
        solutiontitle: "<h3>Beneficiile migrării la Magento 2</h3>",
        solution: "<p>Migrarea platformei www.waterboyz.ro pe Magento 2, a adus o serie de beneficii semnificative companiei Seaside Playgrounds printre care:</p>"
            + "<ul style='list-style:disc;'>"
            + "<li>management al conținutului platformei mult mai operativ</li>"
            + "<li>expunere mai eficientă a catalogului de produse</li>"
            + "<li>interacțiunea îmbunătățită a clienților B2B cu oferta companiei</li>"
            + "<li>un proces de analiză a cererilor de ofertă și de ofertare automatizată ce a generat o optimizare a activității echipei de vânzări </li>"
            + "</ul>"
            + "<p>În timpul procesului de migrare a platformei waterboyz.ro, compania Seaside Playgrounds a beneficiat de consultanța și expertiza din partea unei dintre cele mai mari agenții de Marketing Digital din România, iar echipa acestora a jucat un rol esențial în asigurarea procesului de migrare și alinierea acestuia cu bunele practici ale Google, respectiv că website-ul www.waterboyz.ro a îndeplinit toate cerințele tehnice necesare pentru a fi indexat și poziționat cât mai sus în rezultatele motoarelor de căutare.</p>",
        
        image_benefits: {
            path: '../../assets/casestudies/waterboyz/benefits',
            ext: 'png',
            alt: 'Waterboyz',
        },
        benefitstitle: "<h3>Magento 2, o soluție ușor adaptabilă proiectelor B2B</h3>",
        benefits: "<p>Colaborarea strânsă dintre echipele Zento, a echipei Seaside Playgrounds, a echipei soluției ERP-ului, și a echipei agenției de Marketing Digital ERP-ului a dus la reușita migrării platformei www.waterboyz.ro pe Magento 2. Optimizarea funcționalităților și implementarea caracteristicilor specifice B2B au adus multiple beneficii, iar cu această reușită compania Seaside Playgrounds și-a consolidat poziția pe piață și și-a optimizat prezența online pentru a satisface nevoile clienților lor B2B. Această migrare reușită demonstrează abilitățile și competențele echipei Zento în implementarea și furnizarea de soluții de comerț electronic și sprijinirea afacerilor B2B în automatizarea și optimizarea proceselor de management, ofertare și vânzare online.</p>",

        endtitle: "<h3>Tehnologii & funcții integrate</h3",
        end: "<ul style='list-style:disc;'>"
            + "<li>Modul personalizat cerere ofertă</li>"
            + "<li>Funcție sincronizare catalog produse între ERP și magazinul online</li>"
            + "<li>Funcție sincronizare cereri de oferte între magazinul online și ERP</li>"
            + "<li>Specificații SEO on-page</li>"
            + "<li>Facebook Conversion API</li>"
            + "<li>Landing Page personalizat</li>"
            + "<li>Multi-limbă</li>"
            + "<li>Blog</li>"
            + "</ul>",
    },
    // {
    //     code: 'bellabike',
    //     name: 'BellaBike',
    //     labels: ['sport','fitness'],
    //     // liveurl: '',
    //     thumb: {
    //         path: '../../assets/casestudies/bellabike/thumb',
    //         ext: 'png',
    //         alt: 'Studiu de caz BellaBike',
    //     },

    //     image_hero: {
    //         path: '../../assets/casestudies/bellabike/hero',
    //         ext: 'png',
    //         alt: 'Studiu de caz BellaBike',
    //     },
    //     brief: 'Ziaja este un producător de cosmetice de înaltă calitate, bazate pe ingrediente naturale pentru îngrijirea feței, corpului și părului. Compania a fost fondată în 1898 de doi farmaciști, Aleksandra și Zenon Ziaja.',

    //     introheading: 'Ziaja lansează canalul de vânzare Direct-to-Consumer folosind Zento',
    //     // introtitle: '<h3></h3>',
    //     // intro: "<p></p>"
    //     //     + "<p></p>",

    //     image_about: {
    //         path: '../../assets/casestudies/bellabike/about',
    //         ext: 'png',
    //         alt: 'Studiu de caz BellaBike',
    //     },
    //     abouttitle: "<h2>Despre Ziaja</h2>",
    //     about: "<p>Din pasiunea pentru cosmetice și din dorința de a crea preparate terapeutice de îngrijire a pielii cu cele mai simple formule, bazate pe experiența farmaceutică și inspirate de clima aspra de coastă Ziaja și-a gândit produsele astfel încât să respecte, principiul onestității, asigurând un preț corect pentru calitatea oferită. Concentrată pe îmbunătățirea și dezvoltarea continuă, Ziaja elaborează produse inovatoare atât din grija pentru piele, cat și pentru mediul înconjurător.</p>"
    //         + "<p>Fiecare formulă este fabricată cu mare grija în conformitate cu cerințele legislației Uniunii Europene în domeniul cosmeticelor.</p>",
            
    //     image_challenge: {
    //         path: '../../assets/casestudies/bellabike/challenge',
    //         ext: 'png',
    //         alt: 'BellaBike',
    //     },
    //     challengetitle: "<h3>Provocarea lansării unui magazin online D2C localizat pe piața din România.</h3>",
    //     challenge: "<p>Cu peste 1.000 de produse în portofoliu, brandul Ziaja are deja o prezență în retailul din România, însă pentru a crește vânzările și poziționarea brandului,  Ziaja și-a propus să-și lanseze propriul magazin online (direct-to-customer), un concept care a prins avânt, mai ales în perioada pandemiei.</p>"
    //         + "<p>Având deja o identitate vizuală bine definită offline, provocarea a constat în acomodarea elementelor și specificațiilor manualului de brand în interfața magazinului online, care trebuie să se alinieze tuturor website-urilor internaționale.</p>",

    //     image_solution: {
    //         path: '../../assets/casestudies/bellabike/solution',
    //         ext: 'png',
    //         alt: 'BellaBike',
    //     },
    //     solutiontitle: "<h3>D2C Zento</h3>",
    //     solution: "<p>Magazinul online Zento a fost alegerea perfectă deoarece capacitățile interfeței vizuale PWA au permis alinierea design-ului la cerințele specificațiilor brandului. Totodată elementele de navigare și filtrare în magazin, cât și funcționalitățile personalizate oferă o experiență de cumpărare plăcută și orientată către așteptările utilizatorilor.</p>",
        
    //     endtitle: "<h3>Fundația solidă Zento cu toate integrările necesare.</h3",
    //     end: "<ul style='list-style:disc;'>"
    //         + "<li>E-mail marketing automation</li>"
    //         + "<li>Marketing pop-up</li>"
    //         + "<li>Plată online cu cardul</li>"
    //         + "<li>Autocompletare căutare produse</li>"
    //         + "<li>Notificări clienți back-in-stock</li></ul>",
    // },
    // {
    //     code: 'ziaja',
    //     name: 'Ziaja',
    //     labels: ['beauty','cosmetics'],
    //     // liveurl: '',
    //     thumb: {
    //         path: '../../assets/casestudies/ziaja/thumb',
    //         ext: 'png',
    //         alt: 'Studiu de caz Ziaja',
    //     },

    //     image_hero: {
    //         path: '../../assets/casestudies/ziaja/hero',
    //         ext: 'png',
    //         alt: 'Studiu de caz Ziaja',
    //     },
    //     brief: 'Ziaja este un producător de cosmetice de înaltă calitate, bazate pe ingrediente naturale pentru îngrijirea feței, corpului și părului. Compania a fost fondată în 1898 de doi farmaciști, Aleksandra și Zenon Ziaja.',

    //     introheading: 'Ziaja lansează canalul de vânzare Direct-to-Consumer folosind Zento',
    //     // introtitle: '<h3></h3>',
    //     // intro: "<p></p>"
    //     //     + "<p></p>",

    //     image_about: {
    //         path: '../../assets/casestudies/ziaja/about',
    //         ext: 'png',
    //         alt: 'Studiu de caz Ziaja',
    //     },
    //     abouttitle: "<h2>Despre Ziaja</h2>",
    //     about: "<p>Din pasiunea pentru cosmetice și din dorința de a crea preparate terapeutice de îngrijire a pielii cu cele mai simple formule, bazate pe experiența farmaceutică și inspirate de clima aspra de coastă Ziaja și-a gândit produsele astfel încât să respecte, principiul onestității, asigurând un preț corect pentru calitatea oferită. Concentrată pe îmbunătățirea și dezvoltarea continuă, Ziaja elaborează produse inovatoare atât din grija pentru piele, cat și pentru mediul înconjurător.</p>"
    //         + "<p>Fiecare formulă este fabricată cu mare grija în conformitate cu cerințele legislației Uniunii Europene în domeniul cosmeticelor.</p>",
            
    //     image_challenge: {
    //         path: '../../assets/casestudies/ziaja/challenge',
    //         ext: 'png',
    //         alt: 'Ziaja Klub',
    //     },
    //     challengetitle: "<h3>Provocarea lansării unui magazin online D2C localizat pe piața din România.</h3>",
    //     challenge: "<p>Cu peste 1.000 de produse în portofoliu, brandul Ziaja are deja o prezență în retailul din România, însă pentru a crește vânzările și poziționarea brandului,  Ziaja și-a propus să-și lanseze propriul magazin online (direct-to-customer), un concept care a prins avânt, mai ales în perioada pandemiei.</p>"
    //         + "<p>Având deja o identitate vizuală bine definită offline, provocarea a constat în acomodarea elementelor și specificațiilor manualului de brand în interfața magazinului online, care trebuie să se alinieze tuturor website-urilor internaționale.</p>",

    //     image_solution: {
    //         path: '../../assets/casestudies/ziaja/solution',
    //         ext: 'png',
    //         alt: 'Ziaja',
    //     },
    //     solutiontitle: "<h3>D2C Zento</h3>",
    //     solution: "<p>Magazinul online Zento a fost alegerea perfectă deoarece capacitățile interfeței vizuale PWA au permis alinierea design-ului la cerințele specificațiilor brandului. Totodată elementele de navigare și filtrare în magazin, cât și funcționalitățile personalizate oferă o experiență de cumpărare plăcută și orientată către așteptările utilizatorilor.</p>",
        
    //     endtitle: "<h3>Fundația solidă Zento cu toate integrările necesare.</h3",
    //     end: "<ul style='list-style:disc;'>"
    //         + "<li>E-mail marketing automation</li>"
    //         + "<li>Marketing pop-up</li>"
    //         + "<li>Plată online cu cardul</li>"
    //         + "<li>Autocompletare căutare produse</li>"
    //         + "<li>Notificări clienți back-in-stock</li></ul>",
    // },
    {
        code: 'electriclight',
        name: 'Electric Light',
        labels: ['home','electrics'],
        liveurl: 'www.electriclight.ro',
        thumb: {
            path: '../../assets/casestudies/electriclight/thumb',
            ext: 'png',
            alt: 'Studiu de caz Electric Light',
        },

        image_hero: {
            path: '../../assets/casestudies/electriclight/hero',
            ext: 'png',
            alt: 'Studiu de caz Electric Light',
        },
        brief: 'După o vastă experiență în piața din România, Electric Light își propune să devină un jucător cheie în piața online de electrice și smart-home cu un variat catalog de produse destinate consumatorilor și profesioniștilor.',

        introheading: 'Din pasiune pentru lumină, calitate și profesionalism',
        introtitle: '<h3>Proiectul Electric Light, împreună cu mascota Mr. Light s-au născut din pasiune pentru lumină, calitate și profesionalism</h3>',
        intro: "<p>Electric Light aduce la lumină viziunea unei echipe de oameni pasionați, cu expertiză în domeniul materialelor electrice și produselor de iluminat moderne și, nu în ultimul rând, a celor mai eficiente soluții oferite clienților.</p>",
        
        image_about: {
            path: '../../assets/casestudies/electriclight/about',
            ext: 'png',
            alt: 'Mr Light by Electric Light',
        },
        abouttitle: "<h2>Despre Electric Light</h2>",
        about: "<p>Cu o experiență cumulată de peste 20 de ani, 15 depozite în România și peste 10,000 de produse diferite, misiunea Electric Light este de a  pune la dispoziție cea mai diversă gamă de produse de iluminat, accesorii și servicii, mereu la prețuri corecte.</p>"
            + "<p>În pas cu dinamismul industriei energetice Electric Light caută mereu cele mai eficiente soluții pentru nevoile clienților, indiferent dacă au nevoie doar de un nou bec care să lumineze colțul preferat din camera de zi sau se dorește schimbarea temperaturii luminilor din dormitor, direct de pe telefonul mobil</p>"
            + "<p>Obiectivul magazinului Electric Light este să devină un one-stop-shop este toate materialele și echipamentele electrice de care este nevoie pentru orice proiect de construcție sau renovare.</p>",
    
        image_challenge: {
            path: '../../assets/casestudies/electriclight/challenge',
            ext: 'jpg',
            alt: 'Electric Light',
        },
        challengetitle: "<h3>Provocarea</h3>",
        challenge: "<p>Implementarea proiectului Electric Light a avut la bază integrarea catalogului de produse al aplicației ERP cu magazinul online pentru peste 10.000 de produse, fiecare cu specificații tehnice extinse: de la descriere, iconițe reprezentative personalizate, specificații tehnice complexe și multiple atașamente, astfel încât utilizatorii să identifice cu ușurință detaliile produselor și factori diferentiatori ale brandului Electric Light.</p>"
            + "<p>Totodată s-a dorit și crearea unei identități ale brandului care să rezoneze cu oferta de produse și servicii ale Electric Light.</p>"
            + "<p>Având în vedere că industria Home & Deco necesită expunerea creativă a portofoliului de produse, dar și experiența imersiva Electric Light și-a asumat rolul de a oferii cumpărătorilor întocmai experiențe de cumpărături diferite și inovative, astfel s-a dorit integrarea unor soluții terțe tip 3D/Tur virtual al unui showroom.</p>",
        
        image_solution: {
            path: '../../assets/casestudies/electriclight/solution',
            ext: 'png',
            alt: 'Electric Light',
        },
        solutiontitle: "<h3>Realizarea brandului și a magazinului online Zento</h3>",
        solution: "<p>Atât logo-ul Electric Light, cât și mascota “Mr Light” create pentru a da viață proiectului, au stat la baza design-ului personalizat, care a ajuns la criteriile de acceptanță impuse în câteva iterații.</p>"
            + "<p>Odată ce partea vizuală a fost aprobată, a fost demarat procesul de integrarea a catalogului de produse prin preluarea dinamică a informațiilor acestora din mai multe surse, asincron. Funcțiile ERP-ului, cât și a platformei Magento au permis automatizarea datelor în cel mai mic detaliu și cu o recurență inteligentă a întregului catalog de produselor.</p>"
            + "<p>Totodată, fluxul operațional integrat a permis automatizarea procesării comenzilor, emiterea și expedierea facturilor către clienții finali, dar și expunerea facturilor în conturile acestora.</p>",
        
        endtitle: "<h3>Azi, indiferent dacă renovezi sau construiești, Mr.Light, – electricianul tău digital este alături de tine.</h3",
        end: "<ul style='list-style:disc;'>"
            + "<li>Funcții sincronizare bidirecționale date ERP</li>"
            + "<li>Showroom Virtual</li>"
            + "<li>E-mail marketing automation </li>"
            + "<li>Plată online cu cardul</li>"
            + "<li>Serviciu SELF-AWB</li>"
            + "<li>Actualizare catalog produse automat </li>"
            + "<li>Autocompletare căutare produse</li>"
            + "<li>Index producători</li>"
            + "<li>Preluare feed-uri furnizori</li></ul>",
    },
    // {
    //     code: 'nanis',
    //     name: 'Nanis',
    //     labels: ['kids','clothing'],
    //     liveurl: 'www.nanis.ro',
    //     thumb: {
    //         path: '../../assets/casestudies/nanis/thumb',
    //         ext: 'png',
    //         alt: 'Studiu de caz Nanis',
    //     },

    //     image_hero: {
    //         path: '../../assets/casestudies/nanis/hero',
    //         ext: 'png',
    //         alt: 'Studiu de caz Nanis',
    //     },
    //     brief: 'Brandul Nanis se poziționează ca fiind cel mai mare magazin online dedicat creșterii și de dezvoltării armonioase a copiilor în primii ani de viață., având o echipă de experți cu idei și concepții inovative, specializată și acreditată în domeniu.',

    //     introheading: 'Nanis prezintă cele mai cunoscute și de încredere brand-uri de pe piață',
    //     // introtitle: '<h3></h3>',
    //     // intro: "<p></p>",
        
    //     image_about: {
    //         path: '../../assets/casestudies/nanis/about',
    //         ext: 'png',
    //         alt: 'Nanis',
    //     },
    //     abouttitle: "<h2>Provocarea în lansare unui magazin online integrat.</h2>",
    //     about: "<p>Brandul Nanis adună la un loc cele mai cunoscute și de încredere brand-uri de pe piață, și acoperă un portofoliu de peste 5.000 de produse.</p>"
    //         + "<p>Pentru a-și atinge obiectivele de business proiectul Nanis avea nevoie să dezvolte un magazin online integrat cu sistemele de management interne, de la ERP, la serviciile de marketing online, dar și cu sistemul de catalog online al furnizorilor și logistică, astfel s-a ales o platformă de eCommerce renumită, care însă din motive tehnice nu a reușit să armonizeze acest flux de lucru, și astfel a fost abandonată.</p>",
    
    //     image_challenge: {
    //         path: '../../assets/casestudies/nanis/challenge',
    //         ext: 'jpg',
    //         alt: 'Nanis',
    //     },
    //     challengetitle: "<h3>Provocările unei replatformizări</h3>",
    //     challenge: "<p>Planul de replatformizare pe Zento a fost făcut analizând toate componentele ce urmau să fie integrate pe magazinul online, astfel încât la momentul lansării operațiunile de management ale magazinului să fie operaționale în limitele bugetului și calendarului de implementare.</p>",
        
    //     image_solution: {
    //         path: '../../assets/casestudies/nanis/solution',
    //         ext: 'png',
    //         alt: 'Nanis by Zento',
    //     },
    //     solutiontitle: "<h3>Replatformizarea pe Zento</h3>",
    //     solution: "<p>Având în vedere complexitatea platformei Magento, și flexibilitatea acesteia, integrarea cu componentele terțe s-au realizat cu ușurință în procesul de livrare al magazinului. Ulterior a fost demarat și procesul de promovare online al magazinului, în conformitate cu recomandările platformelor consacrate privind performanța magazinelor online.</p>"
    //         + "<p>Fluxul operațional include actualizare bi-direcțională de informații între ERP și magazinul online, astfel toate activitățile ce includ actualizare catalogului de produse și management comenzi a fost automatizat.</p>",
        
    //     endtitle: "<h3>Servicii Integrate</h3",
    //     end: "<ul style='list-style:disc;'>"
    //         + "<li>Funcții sincronizare bidirecționale date ERP</li>"
    //         + "<li>E-mail marketing automation</li>"
    //         + "<li>Marketing pop-up</li>"
    //         + "<li>Plată online cu cardul</li>"
    //         + "<li>Actualizare catalog produse automat</li>"
    //         + "<li>Autocompletare căutare produse</li>"
    //         + "<li>Index producători</li>"
    //         + "<li>Notificări clienți back-in-stock</li>"
    //         + "<li>Preluare feed-uri furnizori</li>"
    //         + "</ul>",
    // },
    {
        code: 'bitolia',
        name: 'Bitolia',
        labels: ['fashion'],
        liveurl: 'www.bitolia.ro',
        thumb: {
            path: '../../assets/casestudies/bitolia/thumb',
            ext: 'png',
            alt: 'Studiu de caz Bitolia',
        },

        image_hero: {
            path: '../../assets/casestudies/bitolia/hero',
            ext: 'png',
            alt: 'Studiu de caz Bitolia',
        },
        brief: 'Bitolia.ro este o poveste despre arta transpusă în colecții vestimentare pentru orice stil, de la ținute de casă, casual, până la ținute de lux create pentru evenimentele speciale, cu materiale și accesorii de top, ce asigură fiecărui produs autenticitate și personalitate.',

        introheading: 'O experiență exclusivistă transpusă din offline în online',
        // introtitle: '<h3></h3>',
        // intro: "<p></p>",
        
        image_about: {
            path: '../../assets/casestudies/bitolia/about',
            ext: 'png',
            alt: 'Bitolia',
        },
        abouttitle: "<h2>Brandul Bitolia</h2>",
        about: "<p><strong>Brandul</strong> BITOLIA GALLERY - The Art of Fashion, este o poveste despre arta transpusă în colecții vestimentare pentru orice stil sau moment al zilei. De la ținute de casă, casual, office sau elegante, până la ținute de lux create pentru evenimentele speciale din viața ta, lucrate exclusiv manual, cu materiale și accesorii de top, ce asigură fiecărui produs autenticitate și personalitate, semnătura Bitolia Gallery.</p>"
            + "<p><strong>Experiența</strong>. Bitolia este mai mult decât un brand de creații vestimentare, este o experiență unică sub acoperișul clădirii Bitolia No. 5, București,  în care stilul este o stare de spirit, iar rafinamentul se exprimă prin decorurile unice și elegante.</p>"
            + "<p><strong>Misiunea</strong>. La baza experienței Bitolia Gallery este misiunea brandului ce constă în crearea de ținute personalizate, cei vor exprima stilul într-un mod unic. Brandul oferă consultanță specializată prin asistență permanentă a personalului din galerie, precum și a stiliștilor croitori ce pot ajusta piesele după măsurile clienților.</p>",
    
        image_challenge: {
            path: '../../assets/casestudies/bitolia/challenge',
            ext: 'jpg',
            alt: 'Bitolia',
        },
        challengetitle: "<h3>Provocarea lansării unui magazin online concept &ldquo;fashion design&rdquo;</h3>",
        challenge: "<p>Bitolia deținea un website cu funcții de eCommerce însă funcționalitățile și design-ul acestuia nu reflectau poziționarea brandului în online la nivelul experienței offline.</p>"
            + "<p>Totodată activitățile de marketing online nu performau deoarece performanța tehnică a website-ului era foarte slabă.</p>",
        
        image_solution: {
            path: '../../assets/casestudies/bitolia/solution',
            ext: 'png',
            alt: 'Bitolia',
        },
        solutiontitle: "<h3>Magazinul online Bitolia pe platforma Zento</h3>",
        solution: "<p>S-a dorit implementarea unui design nou și a unei experiențe de cumpărături online cu focus către utilizarea pe mobil, totodată urmărindu-se identificarea unei partener pe termen lung care să ofere suport post-implementare și să asigure performanța și buna funcționarea magazinului online, având în vedere dinamica pieței, și a nevoi de adaptare la aceasta.</p>"
            + "<p>Magazinul online Zento a fost alegerea ideală care să pună în evidență exclusivitatea brandului cât și performanța oferită de platformă, astfel încât atât din punct de vedere al design-ului, cât și a tehnologiei și experienței de cumpărare să potențeze experiența similară în offline a brandului Bitolia.</p>",
        
        endtitle: "<h3>Servicii Integrate</h3",
        end: "<ul style='list-style:disc;'>"
            + "<li>E-mail marketing automation</li>"
            + "<li>Marketing pop-up</li>"
            + "<li>Plată online cu cardul</li>"
            + "<li>Autocompletare căutare produse</li>"
            + "<li>Notificări clienți back-in-stock</li>"
            + "</ul>",
    }
];
export default casestudies;
